export function FormLabel({ label = "" }) {
  return <label className="form-label">{label}</label>;
}
